module.exports = __webpack_public_path__ + "img/accounting.3ff40893.svg";